import styled from "@emotion/styled";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setalertMessagetype,
  setalertMessage,
  setSessionExpire,
  setLoginStatus,
  setLoginModalOpen,
  setLogInLoading,
  setaccessToken,
  SetRedirectPage,
  setAuthuser,
  setEmailVerify,
  setProfileStatus,
  setWalletBalance,
  setAccountCompleted,
} from "redux/redux-slice";
import { EquipmentAPIs } from "service/api-service";
import { IStoreValue } from "utils/types";

const CssTextField = styled(TextField)({
  "& .MuiInputBase-root": {
    color: "#2e2e2e",
    background: "#fff",
    fontFamily: "GothamBold !important",
    fontSize: "clamp(12px, 3vw, 15px) !important",
  },
  "& label.Mui-focused": {
    color: "#faa61a",
    fontWeight: "bold",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#2e2e2e",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "2px solid #faa61a",
    },
    "&:hover fieldset": {
      borderColor: "#2e2e2e",
      border: "2px solid #faa61a",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#faa61a",
    },
  },
});

const AccountAction = ({ type, userInfo, onComplete }) => {
  const dispatch = useDispatch();
  const authToken = useSelector(
    (state: IStoreValue) => state.equipmentReducer.accessToken
  );

  const RedirectPage = useSelector(
    (state: IStoreValue) => state.equipmentReducer.RedirectPage
  );

  //console.log('userInfo', userInfo)
  const [loginType, setloginType] = useState("");
  const [confirmation, setConfirmation] = useState(true);
  //   const [isLoading, setIsLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [userEmail, setuserEmail] = useState("");

  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserPassword(event.target.value.trim());
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setuserEmail(event.target.value.trim());
  };

  const handleCloseAccount = async () => {
    try {
      setIsLoading(true);
      const password = userPassword;
      const { login_type, user_id } = userInfo;

      if (!password && login_type === "N") {
        dispatch(setalertMessage("Please fill password first."));
        dispatch(setalertMessagetype("error"));
        setIsLoading(false);
        return;
      }

      const body = {
        user_id: user_id.toString(),
        password,
        login_type,
        request_from: "Website",
      };

      const headers = { Authorization: `${authToken}`, request_from: "Web" };
      const result = await EquipmentAPIs.CloseAccount(body, headers);

      if (result && result["type"] == "RXSUCCESS") {
        // setaccountClosedSuccess(true);
        // setaccountClosedSuccessMessage(result.message);
        // dispatch(setalertMessage(result.message));
        // dispatch(setalertMessagetype("success"));
        setUserPassword("");

        localStorage.clear();
        dispatch(setLogInLoading(false));
        dispatch(setLoginStatus(false));
        dispatch(setaccessToken(null));
        dispatch(setProfileStatus(false));
        dispatch(setEmailVerify(0));
        dispatch(setWalletBalance(0));
        dispatch(setAccountCompleted(0));

        onComplete("success", result.message);
        // setTimeout(() => {
        //     window.location.href = "/";
        // }, 1200);
      } else {
        dispatch(setalertMessage(result?.message || "Something went wrong."));
        dispatch(setalertMessagetype("error"));
      }
    } catch (error) {
      console.error(error);
      dispatch(setalertMessage("An unexpected error occurred."));
      dispatch(setalertMessagetype("error"));
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Account Restore Action
  const handleRestore = async () => {
    try {
      setIsLoading(true);
      const { user_id, login_type } = userInfo;
      const body = {
        user_id,
        login_type,
        request_from: "Website",
      };

      const headers = { Authorization: `${authToken}`, request_from: "Web" };
      const result = await EquipmentAPIs.RestoreAccount(body, headers);

      if (result && result["type"] == "RXSUCCESS") {
        dispatch(setalertMessage(result.message));
        dispatch(setalertMessagetype("success"));
        setuserEmail("");
        setUserPassword("");

        let auth_user = result["data"];
        localStorage.setItem("token-info", JSON.stringify(auth_user));
        dispatch(setaccessToken(result["data"]["auth_token"]));
        dispatch(setAuthuser(result["data"]["user_id"]));
        dispatch(setEmailVerify(result["data"]["is_user_verify"]));
        dispatch(setLoginStatus(true));
        dispatch(setLoginModalOpen(false));
        //onComplete('success');

        setTimeout(() => {
          window.location.href = "/";
        }, 1200);
      } else {
        dispatch(setalertMessage(result?.message || "Something went wrong."));
        dispatch(setalertMessagetype("error"));
      }
    } catch (error) {
      console.log(error);
      dispatch(setalertMessage("An unexpected error occurred."));
      dispatch(setalertMessagetype("error"));
    } finally {
      setIsLoading(false);
    }
  };

  //Handle close account button direct if socal account
  const closeAccountHandle = () => {
    if (userInfo.login_type != "N") {
      handleCloseAccount();
    } else {
      setConfirmation(false);
    }

    // setIsLoading(true);
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 250);
  };

  useEffect(() => {
    setloginType(userInfo.login_type);
    setTimeout(() => {
      setIsLoading(false);
    }, 250);
  }, []);

  return (
    <>
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box sx={{ p: 4 }}>
        {/* <Typography variant="h5" sx={{ color: "#faa61a" }}>
          {type}
        </Typography>
        <br></br> */}

        {type === "Close Account" ? (
          <Box>
            {confirmation ? (
              <Box
                sx={{
                  backgroundColor: "#2d2d2d",
                  color: "#fff",
                  // padding: 3,
                  borderRadius: 2,
                  // maxWidth: 400,
                  mx: "auto",
                  // boxShadow: "0 0 10px rgba(0,0,0,0.5)",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#FFA726", mb: 2 }}
                >
                  Close your account? What that means:
                </Typography>

                <Typography variant="body2" sx={{ mb: 2, fontSize: "16px" }}>
                  We’re sorry to see you go. Are you sure you want to close your
                  GoEquipMe account? You can reopen your account at any time by
                  logging back in.
                </Typography>

                <ul
                  style={{
                    paddingLeft: 18,
                    marginBottom: 16,
                    listStyle: "none",
                  }}
                >
                  <li
                    style={{
                      marginBottom: 6,
                      position: "relative",
                      paddingLeft: 12,
                    }}
                  >
                    <span style={{ position: "absolute", left: 0 }}>-</span>
                    You will not be able to book rentals or list your equipment
                    while your account is closed
                  </li>
                  <li
                    style={{
                      marginBottom: 6,
                      position: "relative",
                      paddingLeft: 12,
                    }}
                  >
                    <span style={{ position: "absolute", left: 0 }}>-</span>
                    Your profile and account data will not be publicly visible
                    on our app or website
                  </li>
                  <li
                    style={{
                      marginBottom: 6,
                      position: "relative",
                      paddingLeft: 12,
                    }}
                  >
                    <span style={{ position: "absolute", left: 0 }}>-</span>
                    Any active or pending rentals may be cancelled
                  </li>
                  <li
                    style={{
                      marginBottom: 6,
                      position: "relative",
                      paddingLeft: 12,
                    }}
                  >
                    <span style={{ position: "absolute", left: 0 }}>-</span>
                    You can reactivate your account anytime by logging back in
                    or contacting support
                  </li>
                  <li style={{ position: "relative", paddingLeft: 12 }}>
                    <span style={{ position: "absolute", left: 0 }}>-</span>
                    You remain financially responsible for any fees, claims, or
                    reimbursements related to your past or pending bookings.
                  </li>
                </ul>

                <Typography sx={{ fontWeight: 600, color: "#FFA726", mb: 2 }}>
                  Do you want to continue?
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 4,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#E61A23",
                      "&:hover": { backgroundColor: "#b81118" },
                      fontWeight: "bold",
                      borderRadius: "8px",
                      px: 3,
                      textTransform: "none",
                      fontSize:"18px"
                    }}
                    onClick={closeAccountHandle}
                  >
                    Continue
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#FFB74D",
                      "&:hover": { backgroundColor: "#FFA726" },
                      color: "#000",
                      fontWeight: "bold",
                      borderRadius: "8px",
                      px: 3,
                      textTransform: "none",
                      fontSize:"18px"
                    }}
                    onClick={() => onComplete("close")}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box>
                {loginType == "N" && (
                  <FormControl fullWidth>
                    <CssTextField
                      variant="outlined"
                      placeholder="Password"
                      type={showNewPassword ? "text" : "password"}
                      value={userPassword}
                      onChange={handlePasswordChange}
                      inputProps={{ maxLength: 10 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowNewPassword}
                              edge="end"
                            >
                              {showNewPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                )}

                <Button
                  type="button"
                  variant="contained"
                  sx={{
                    fontFamily: "Montserrat!important",
                    fontWeight: 800,
                    borderRadius: "8px",
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                      lg: "16px",
                      xl: "18px",
                    },
                    width: "40%",
                    textTransform: "none",
                    mt: 3,
                    mb: 2,
                    backgroundColor: "rgb(20, 146, 71)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mx: "auto",
                    "&:hover": { background: "rgb(46, 125, 50)" },
                  }}
                  onClick={handleCloseAccount}
                >
                  Close Account
                </Button>
              </Box>
            )}
          </Box>
        ) : (
          // Account Restore section
          <Box>
            {confirmation ? (
              <Box>
                <Typography variant="h5" sx={{ color: "#faa61a" }}>
                  {type}
                </Typography>
                <br></br>
                <Typography variant="h6" sx={{ color: "#fff" }}>
                  {userInfo.message || ""} Are you sure you want to restore your
                  account?
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                    mb: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2, // or use columnGap: 2 for horizontal space between buttons
                  }}
                >
                  <Button
                    sx={{
                      background: "#E61A23",
                      color: "#fff",
                      textTransform: "capitalize",
                      fontFamily: "Montserrat !important",
                      borderRadius: "8px",
                      fontWeight: "800",
                      padding: "7px 15px",
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                        lg: "16px",
                        xl: "18px",
                      },
                      "&:hover": {
                        background: "#b81118",
                      },
                    }}
                    onClick={() => {
                      onComplete("close");
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    sx={{
                      background: "rgb(20, 146, 71)",
                      color: "#fff",
                      textTransform: "capitalize",
                      fontFamily: "Montserrat !important",
                      borderRadius: "8px",
                      fontWeight: "800",
                      padding: "7px 15px",
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                        lg: "16px",
                        xl: "18px",
                      },
                      "&:hover": {
                        background: "rgb(46, 125, 50)",
                      },
                    }}
                    onClick={() => {
                      handleRestore();
                      //setConfirmation(false);
                      //   setIsLoading(true);
                      //   setTimeout(() => {
                      //     setIsLoading(false);
                      //   }, 250);
                    }}
                  >
                    Ok
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box>
                <br></br>
                <FormControl fullWidth>
                  <CssTextField
                    variant="outlined"
                    placeholder="Email"
                    type="email"
                    value={userEmail}
                    onChange={handleEmailChange}
                    inputProps={{ maxLength: 25 }}
                  />
                </FormControl>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  sx={{
                    background: "rgb(20, 146, 71)",
                    color: "#fff",
                    textTransform: "capitalize",
                    fontFamily: "Montserrat !important",
                    borderRadius: "8px",
                    fontWeight: "800",
                    padding: "7px 15px",
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                      lg: "16px",
                      xl: "18px",
                    },
                    "&:hover": {
                      background: "rgb(46, 125, 50)",
                    },
                  }}
                  onClick={handleRestore}
                >
                  Restore Account
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};

export default AccountAction;
